var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCovidUnknown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&gt;", /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M50 5a45 45 0 1 0 45 45A45 45 0 0 0 50 5Zm4.19 70h-8.78v-8.65h8.78ZM66 45.16q-1.77 2.8-7.58 7.63a14.49 14.49 0 0 0-3.73 4 13.47 13.47 0 0 0-.69 5.45h-8.59v-2.26a15.05 15.05 0 0 1 1.38-6.89 21 21 0 0 1 5.5-6.09 41.42 41.42 0 0 0 5-4.42 5.91 5.91 0 0 0 1.25-3.65 6.14 6.14 0 0 0-2.24-4.73 8.62 8.62 0 0 0-6-2 9 9 0 0 0-6 2.06 11 11 0 0 0-3.3 6.3h-8.71a16.93 16.93 0 0 1 5.15-11.37Q42.17 25 49.93 25q8.17 0 13 4.27a12.93 12.93 0 0 1 4.83 9.94A10.94 10.94 0 0 1 66 45.16Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidUnknown);
export default __webpack_public_path__ + "static/media/covid_unknown.0608aa096c0da00f3439d575c3d4c88a.svg";
export { ForwardRef as ReactComponent };